import React, { useState, useEffect } from "react";
import DashboardIcon from "../../assets/icons/DashboardIcon";
import MyKeysIcon from "../../assets/icons/MyKeysIcon";
import UserIcon from "../../assets/icons/UserIcon";
import LicenseRecordsIcon from "../../assets/icons/LicenseRecordsIcon";
import AppIcon from "../../assets/icons/AppIcon";
import SubsIcon from "../../assets/icons/SubsIcon";
import Logo from "../../assets/transparent-Logo.png";

export default function Sidebar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [textVisible, setTextVisible] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);


  useEffect(() => {
    const checkIfMobile = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);

      if (!mobile) {
        setIsOpen(true);
        setTextVisible(true);
      } else {
        setIsOpen(false);
        setTextVisible(false);
      }
    };

    checkIfMobile();

    window.addEventListener("resize", checkIfMobile);

    return () => window.removeEventListener("resize", checkIfMobile);
  }, []);

  useEffect(() => {
    let timer;
    if (isOpen) {
      timer = setTimeout(() => {
        setTextVisible(true);
      }, 150);
    } else {
      setTextVisible(false);
    }
    return () => clearTimeout(timer);
  }, [isOpen]);

  const toggleSidebar = () => {
    setIsOpen((prevState) => !prevState);
  };

  const navItems = [
    {
      icon: <DashboardIcon />,
      text: "Dashboard",
      href: "/dashboard",
    },
    {
      icon: <MyKeysIcon />,
      text: "My keys",
      href: "/my-licenses",
    },
    {
      icon: <UserIcon />,
      text: "Users",
      href: "/users",
    },
    {
      icon: <LicenseRecordsIcon />,
      text: "License Records",
      href: "/license-records",
    },
    {
      icon: <AppIcon />,
      text: "Applications",
      href: "/applications",
    },
    {
      icon: <SubsIcon />,
      text: "Subscriptions",
      href: "/subscriptions",
    },
  ];

  const gradientBg = {
    background:
      "linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.12) 100%)",
  };

  const hoverGradient = {
    background:
      "linear-gradient(90deg, rgba(137,168,176,0.1512) 0%, rgba(255,255,255,0) 100%)",
  };

  return (
    <>
      <div className={`flex ${isMobile ? "w-20" : ""}`}>
        {/* Unified Sidebar with Tailwind classes */}
        <div
          style={isMobile ? { background: "#000" } : gradientBg}
          className={` text-white flex flex-col items-center py-6 transition-all duration-300 ease-in-out shadow-lg z-40 ${isOpen ? "w-64" : "w-20"} lg:w-[18%] lg:min-w-[256px] fixed lg:relative `}
        >
          <div className="relative w-full flex justify-center mb-6">
            <img
              src={Logo}
              alt="Logo"
              className={`max-w-full transition-transform duration-300 ${!isOpen ? "scale-75" : ""}`}
            />

            {/* Toggle button - visible on mobile */}
            <button
              className={`
                absolute p-2 rounded-md text-white
                ${!isOpen ? "left-20" : "right-2"} top-0
                ${!isMobile && isOpen ? "lg:hidden" : ""}
              `}
              onClick={toggleSidebar}
              aria-label="Toggle menu"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d={
                    isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"
                  }
                />
              </svg>
            </button>
          </div>

          <nav className="w-full">
            <ul
              className={`space-y-3 transition-all duration-300 ${isOpen ? "px-6" : "px-2"}`}
            >
              {navItems
                .filter((nav) => nav)
                .map((item, index) => (
                  <li key={index} className="w-full">
                    <a
                      href={item.href}
                      className={`
                      flex items-center rounded-md transition-all duration-300
                      border border-transparent hover:border-white/20
                      ${isOpen ? "px-4 py-3" : "justify-center py-3 px-2"}
                      ${!isMobile ? "lg:justify-start lg:px-4 lg:py-3" : ""}
                    `}
                      title={!isOpen ? item.text : ""}
                      style={hoveredIndex === index ? hoverGradient : {}}
                      onMouseEnter={() => setHoveredIndex(index)}
                      onMouseLeave={() => setHoveredIndex(null)}
                    >
                      <span
                        className={`text-lg ${isOpen ? "mr-3" : ""} ${!isMobile ? "lg:mr-3" : ""}`}
                      >
                        {item.icon}
                      </span>

                      {/* Text visibility based on sidebar state */}
                      {textVisible && isOpen && (
                        <span className="whitespace-nowrap transition-opacity duration-200 opacity-100">
                          {item.text}
                        </span>
                      )}
                    </a>
                  </li>
                ))}
            </ul>
          </nav>
        </div>

        {/* Main content area */}
        {/* <div className={`flex-1 ${isMobile ? 'ml-20' : ''} ${isOpen && isMobile ? 'ml-0' : ''} lg:ml-0 transition-all duration-300`}>
        </div> */}
      </div>

      {/* Semi-transparent overlay only when sidebar is expanded on mobile */}
      {isOpen && isMobile && (
        <div
          className="fixed inset-0 bg-black/30 z-30 lg:hidden"
          onClick={toggleSidebar}
        />
      )}
    </>
  );
}
